const replaceWithSpaces = (str, loc, len) => {
  let arr = [...str];
  for (let i = loc; i < loc + len; i++) {
    arr[i] = " ";
  }
  return arr.join("");
};

export default replaceWithSpaces;
